"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ArrowDownLine["default"];
  }
});

var _ArrowDownLine = _interopRequireDefault(require("./lib/icons/ArrowDownLine"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
